// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Node$XodProject = require("./Node.bs.js");
var Maybe$XodFuncTools = require("xod-func-tools/src/Maybe.bs.js");

function listPatches(project) {
  return Belt_List.fromArray($dot$dot.listPatches(project));
}

function listLocalPatches(project) {
  return Belt_List.fromArray($dot$dot.listLocalPatches(project));
}

function assocPatch(project, path, patch) {
  return $dot$dot.assocPatch(path, patch, project);
}

function getPatchByPath(project, path) {
  return Maybe$XodFuncTools.toOption($dot$dot.getPatchByPath(path, project));
}

function getPatchByNode(project, node) {
  var path = Node$XodProject.getType(node);
  return Maybe$XodFuncTools.toOption($dot$dot.getPatchByPath(path, project));
}

function getPatchDependencies(project, patchPath) {
  return Belt_List.fromArray($dot$dot.getPatchDependencies(patchPath, project));
}

function upsertPatches(project, patchList) {
  return $dot$dot.upsertPatches(Belt_List.toArray(patchList), project);
}

exports.listPatches = listPatches;
exports.listLocalPatches = listLocalPatches;
exports.assocPatch = assocPatch;
exports.getPatchByPath = getPatchByPath;
exports.getPatchByNode = getPatchByNode;
exports.getPatchDependencies = getPatchDependencies;
exports.upsertPatches = upsertPatches;
/* .. Not a pure module */



// WEBPACK FOOTER //
// ../src/Project.bs.js